'use client'
import Swiper from '@src/quince-components/src/atoms/swiper'
import { DOTS_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'

import SectionRenderer from '../../SectionRenderer'
import { SectionProps } from '../../SectionRenderer.types'

import styles from './heroCarousel.module.scss'

// Byte-for-byte fork of the pre-DS HeroCarousel. Served on the DS-off path until the DS rollout
// (`RAMP_ds-rollout__web`) reaches 100%. Do not edit behavior here — change the DS variant.
export function HeroCarouselLegacy({ sectionConfig: { subSections, id, tracker, trackingMetaData } }: SectionProps) {
  const sectionRenderer = (idx: number) =>
    SectionRenderer({
      tracker: tracker && `${tracker}__heroCarousel`,
      sectionIndex: idx,
    })

  return (
    <Swiper id="hero-carousel-swiper" dotsPosition={DOTS_POSITION.BOTTOM_HOVER} key={id}>
      {subSections?.map((subSection, idx) => (
        <div key={subSection.id} className={styles.sectionWrapper}>
          {sectionRenderer(idx)({
            ...subSection,
            trackingMetaData: {
              ...trackingMetaData,
              context: {
                ...trackingMetaData?.context,
                horizontalPosition: idx + 1,
              },
            },
          })}
        </div>
      ))}
    </Swiper>
  )
}

export default HeroCarouselLegacy
